<div class="truck-view-container">
  <div class="trip-detail-popup-right">
    <img src="../../../assets/img/icons8-macos-close-60.png" class="close-icons" (click)="close()" />
  </div>
  <div class="driver-view" *ngIf="truckProfile">
    <div class="heading">
      <h3>Truck Profile</h3>
    </div>
    <mat-divider></mat-divider>
    <div class="row m-0">
      <div class="col-md-8">
        <div class="row mtb mr-0 ml-0">
          <div class="col-sm-5">
            <div class="head">Truck Number</div>
            <div class="dec">{{ data.truck_number | uppercase }}</div>
          </div>
          <div class="col-sm-5">
            <div class="head">RC Valid upto</div>
            <div class="dec">{{ data.rc_valid | date : "dd-MM-yyyy" }}</div>
          </div>
        </div>
        <div class="row mb mr-0 ml-0">
          <div class="col-sm-5">
            <div class="head">Home Location</div>
            <div class="dec">{{ data.home_location }}</div>
          </div>
          <div class="col-sm-7">
            <div class="head">Make Name</div>
            <div class="dec">{{ data.make_name }}</div>
          </div>
        </div>
        <div class="row mb mr-0 ml-0">
          <div class="col-sm-5">
            <div class="head">Model</div>
            <div class="dec">{{ data.truck_model }}</div>
          </div>
          <div class="col-sm-7">
            <div class="head">Manufacturing Year</div>
            <div class="dec">{{ data.manufacture_year }}</div>
          </div>
        </div>
        <div class="row mb mr-0 ml-0">
          <div class="col-sm-5">
            <div class="head">Truck Category</div>
            <div class="dec">
              {{ data.truckCategoryInfo[0]?.truck_category_name }}
            </div>
          </div>
          <div class="col-sm-7">
            <div class="head">Truck Type</div>
            <div class="dec">{{ data.truckTypeInfo[0]?.truck_weight }}</div>
          </div>
        </div>
        <div class="row mb mr-0 ml-0">
          <div class="col-sm-5">
            <div class="head">Status</div>
            <div class="dec">{{ data.truck_status }}</div>
          </div>
          <div class="col-sm-7" *ngIf="reasonsView">
            <div class="head">Reasons</div>
            <div class="dec">{{ data.truck_remarks }}</div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="right-side">
          <img src="{{ data.truck_image }}" class="driverImg" />
          <div class="row mr-0 ml-0">
            <div class="col-sm-12">
              <div>
                {{ data.truckCategoryInfo[0].truck_category_name }} -
                {{ data.truckTypeInfo[0].truck_weight }} -
                {{ data.truckTypeInfo[0].truck_feet }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb mr-0 ml-0">
        <div class="col-sm-5">
          <div class="head">Truck Owner</div>
          <div class="dec">
            {{ currentOwner?.username ? currentOwner?.username : "" }}
          </div>
        </div>
      </div>
      <div class="heading">
        <h3>Documents</h3>
      </div>
      <mat-divider class="mb-3"></mat-divider>
      <div class="col-sm-4">
        <div class="head-b">Vehicle RC</div>
      </div>
      <div class="col-sm-4">
        <div class="dec">
          {{
          data.truck_documents_proofs.vehicle_rc_expiry | date : "dd-MM-yyyy"
          }}
        </div>
      </div>
      <div class="col-sm-4">
        <div class="dec-view" *ngIf="data.truck_documents_proofs.vehicle_rc">
          <a target="_blank" href="{{ data.truck_documents_proofs.vehicle_rc }}">View</a>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="head-b">Permit Type</div>
      </div>
      <div class="col-sm-4">
        <div class="dec">
          {{
          data.truck_documents_proofs.permit_type_expiry | date : "dd-MM-yyyy"
          }}
        </div>
      </div>
      <div class="col-sm-4">
        <div class="dec-view" *ngIf="data.truck_documents_proofs.permit_type">
          <a target="_blank" href="{{ data.truck_documents_proofs.permit_type }}">View</a>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="head-b">Fitness</div>
      </div>
      <div class="col-sm-4">
        <div class="dec">
          {{ data.truck_documents_proofs.fitness_expiry | date : "dd-MM-yyyy" }}
        </div>
      </div>
      <div class="col-sm-4">
        <div class="dec-view" *ngIf="data.truck_documents_proofs.fitness">
          <a target="_blank" href="{{ data.truck_documents_proofs.fitness }}">View</a>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="head-b">Pollution</div>
      </div>
      <div class="col-sm-4">
        <div class="dec">
          {{
          data.truck_documents_proofs.pollution_expiry | date : "dd-MM-yyyy"
          }}
        </div>
      </div>
      <div class="col-sm-4">
        <div class="dec-view" *ngIf="data.truck_documents_proofs.pollution">
          <a target="_blank" href="{{ data.truck_documents_proofs.pollution }}">View</a>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="head-b">Insurance</div>
      </div>
      <div class="col-sm-4">
        <div class="dec">
          {{
          data.truck_documents_proofs.insurance_expiry | date : "dd-MM-yyyy"
          }}
        </div>
      </div>
      <div class="col-sm-4">
        <div class="dec-view" *ngIf="data.truck_documents_proofs.insurance">
          <a target="_blank" href="{{ data.truck_documents_proofs.insurance }}">View</a>
        </div>
      </div>
    </div>
    <div>
      <div class="heading">
        <h3>View Notes</h3>
      </div>
      <mat-divider></mat-divider>
      <div class="row mb mt-4 mr-0 ml-0" *ngFor="let item of NotesData; let i = index">
        <div class="col-sm-3">
          <div class="note1">Note {{ i + 1 }}:</div>
          <div class="note2">{{ item.employee_name }}</div>
          <div class="note3">{{ item.createdAt | date : "medium" }}</div>
        </div>
        <div class="col-sm-9">
          <div class="note2">{{ item.notes }}</div>
        </div>
      </div>
    </div>
    <div class="fixed-btn">
      <button (click)="truckEdit()">Edit</button>
    </div>
  </div>

  <!-- ------------------------------Edit Form ------------------------------------ -->

  <div *ngIf="editTruckProfile" class="driver-view">
    <div class="heading">
      <h3>Truck Profile</h3>
    </div>
    <mat-divider></mat-divider>
    <form [formGroup]="editTruckFrom" class="admin-forms mt-3">
      <div class="row m-0 input-fileds-container">
        <div class="col-sm-9 driver-truck">
          <div class="row mtb mr-0 ml-0">
            <div class="col-sm-5">
              <div class="dec">
                <mat-form-field>
                  <mat-label>Truck Number</mat-label>
                  <input toUppercase appAlphanumericOnly matInput formControlName="truck_number" maxlength="10"
                    minlength="6" required />
                  <mat-error>Please enter truck number</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-sm-5">
              <div class="dec">
                <mat-form-field>
                  <mat-label>RC Valid upto</mat-label>
                  <mat-datepicker-toggle matSuffix [for]="picker">
                  </mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                  <input matInput [matDatepicker]="picker" placeholder="RC Valid" [min]="minDate"
                    formControlName="rc_valid" (click)="picker.open()" />
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="row mb mr-0 ml-0">
            <div class="col-sm-5">
              <div class="dec">
                <mat-form-field>
                  <mat-label>Home Location</mat-label>
                  <input matInput formControlName="home_location" />
                </mat-form-field>
              </div>
            </div>
            <div class="col-sm-7">
              <div class="dec">
                <mat-form-field>
                  <mat-label>Make Name</mat-label>
                  <input matInput formControlName="make_name" />
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="row mb mr-0 ml-0">
            <div class="col-sm-5">
              <div class="dec">
                <mat-form-field>
                  <mat-label>Model</mat-label>
                  <input matInput formControlName="truck_model" />
                </mat-form-field>
              </div>
            </div>
            <div class="col-sm-7">
              <div class="dec">
                <mat-form-field>
                  <mat-label>Manufacturing Year</mat-label>
                  <input type="number" matInput formControlName="manufacture_year" />
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="row mtb tax-container mr-0 ml-0">
            <div class="col-sm-5">
              <div class="dec">
                <mat-form-field class="flex-gt-sm example-full-width truck-type-input">
                  <mat-label>Truck Category</mat-label>
                  <mat-select dropLocationSearchField formControlName="truck_category"
                    (selectionChange)="gettruckCatg($event)" required>
                    <mat-option *ngFor="let cat of truckCategory" value="{{ cat._id }}">
                      {{ cat.truck_category_name }}
                    </mat-option>
                  </mat-select>
                  <mat-error>Please enter Truck Category</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-sm-7">
              <div class="dec">
                <mat-form-field>
                  <mat-label>Truck Type</mat-label>
                  <mat-select dropLocationSearchField formControlName="truck_type" required>
                    <mat-option *ngFor="let cat of truckList" value="{{ cat._id }}">
                      {{ cat.truck_weight }}
                    </mat-option>
                  </mat-select>
                  <div *ngIf="isTypeLoading" class="spinner"
                    style="position: absolute; right: 10px; top: 10px; height: 20px; width: 20px;"></div>
                  <mat-error>Please enter Truck Type</mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="row mtb tax-container mr-0 ml-0">
            <div class="col-sm-5">
              <div class="dec">
                <mat-form-field class="flex-gt-sm example-full-width truck-type-input">
                  <mat-label>Truck Owner</mat-label>
                  <mat-select dropLocationSearchField formControlName="truckowner_id" required>
                    <mat-option *ngFor="let truck_owner of truckOwner" value="{{ truck_owner._id }}">
                      {{ truck_owner.username }}
                    </mat-option>
                  </mat-select>
                  <mat-error>Please enter Truck Owner</mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="row mtb tax-container mr-0 ml-0">
            <div class="col-sm-5">
              <div class="dec">
                <mat-form-field class="flex-gt-sm example-full-width truck-type-input">
                  <mat-label>Update</mat-label>
                  <mat-select dropLocationSearchField formControlName="truck_status">
                    <mat-option disabled value="available">
                      Available
                    </mat-option>
                    <mat-option disabled value="allocated">
                      Allocated
                    </mat-option>
                    <mat-option value="maintenance" (click)="maintance()">
                      Maintenance
                    </mat-option>
                    <mat-option value="rejected" (click)="rejected()">
                      Rejected
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="col-sm-5" *ngIf="reasons">
              <div class="dec">
                <mat-form-field class="flex-gt-sm example-full-width truck-type-input">
                  <mat-label>Reasons</mat-label>
                  <input matInput formControlName="truck_remarks" />
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <div [class.spinner]="truckImageloading"></div>
          <div class="right-side">
            <img src="{{ truckImage }}" class="driverImg" />
            <div class="image-upload-area">
              <span class="change-photo-btn" (click)="uploadImage.click()">Change Photo</span>
              <input #uploadImage type="file" (change)="onChange($event, 'Truck')" hidden />
            </div>
          </div>
        </div>
        <div class="head mb">Documents</div>
        <div class="row mb mr-0 ml-0">
          <div class="col-md-4 mb-3 d-flex align-items-center">
            <div class="head-b">Vehicle RC</div>
          </div>
          <div class="col-md-4 mb-3">
            <div class="dec">
              <mat-form-field class="flex-gt-sm example-full-width truck-type-input">
                <mat-datepicker-toggle matSuffix [for]="picker1">
                </mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
                <input matInput formControlName="vehicle_rc_expiry" [matDatepicker]="picker1" placeholder="DD-MM-YYYY"
                  [min]="minDate" (click)="picker1.open()" />
              </mat-form-field>
            </div>
          </div>
          <div class="col-md-4 d-flex align-items-center mb-3">
            <span (click)="uploadRCImage.click()" *ngIf="uploadVehicle" class="image mr-2">Upload
            </span>
            <div *ngIf="updateRC">
              <a target="_blank" href="{{ data.truck_documents_proofs.vehicle_rc }}">{{ RCImageName }}</a>
            </div>
            <div [class.spinner]="rcLoading"></div>
            <span *ngIf="!uploadVehicle">{{ RCImageName }}</span>
            <img src="../../../assets/img/cross.svg" *ngIf="!uploadVehicle" (click)="removeImg($event, 'RC')"
              class="cross-btn" alt="" />

            <input #uploadRCImage type="file" (change)="onChange($event, 'RC')" hidden />
          </div>
          <div class="col-md-4 mb-3 d-flex align-items-center">
            <div class="head-b">Permit Type</div>
          </div>
          <div class="col-md-4 mb-3">
            <div class="dec">
              <mat-form-field>
                <mat-datepicker-toggle matSuffix [for]="picker2">
                </mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
                <input matInput [matDatepicker]="picker2" placeholder="DD-MM-YYYY" [min]="minDate"
                  formControlName="permit_type_expiry" (click)="picker2.open()" />
              </mat-form-field>
            </div>
          </div>
          <div class="col-md-4 d-flex align-items-center mb-3">
            <span (click)="uploadPermitImage.click()" *ngIf="uploadPermit" class="image">Upload
            </span>
            <div *ngIf="updatePermit">
              <a target="_blank" href="{{ data.truck_documents_proofs.permit_type }}">{{ permitImageName }}</a>
            </div>
            <div [class.spinner]="permitLoading"></div>

            <span *ngIf="!uploadPermit">{{ permitImageName }}</span>
            <img src="../../../assets/img/cross.svg" *ngIf="!uploadPermit" (click)="removeImg($event, 'permit')"
              class="cross-btn" alt="" />
            <input #uploadPermitImage type="file" (change)="onChange($event, 'PermitType')" hidden />
          </div>
          <div class="col-md-4 mb-3 d-flex align-items-center">
            <div class="head-b">Fitness</div>
          </div>
          <div class="col-md-4 mb-3">
            <div class="dec">
              <mat-form-field>
                <mat-datepicker-toggle matSuffix [for]="picker3">
                </mat-datepicker-toggle>
                <mat-datepicker #picker3></mat-datepicker>
                <input matInput [matDatepicker]="picker3" placeholder="DD-MM-YYYY" [min]="minDate"
                  formControlName="fitness_expiry" (click)="picker3.open()" />
              </mat-form-field>
            </div>
          </div>
          <div class="col-md-4 d-flex align-items-center mb-3">
            <span (click)="uploadFitnesstImage.click()" *ngIf="uploadFitness" class="image">Upload
            </span>
            <div *ngIf="updateFitness">
              <a target="_blank" href="{{ data.truck_documents_proofs.fitness }}">{{ fitnessImageName }}</a>
            </div>
            <div [class.spinner]="fitnessLoading"></div>
            <span *ngIf="!uploadFitness">{{ fitnessImageName }}</span>
            <img src="../../../assets/img/cross.svg" *ngIf="!uploadFitness" (click)="removeImg($event, 'fitness')"
              class="cross-btn" alt="" />
            <input #uploadFitnesstImage type="file" (change)="onChange($event, 'Fitness')" hidden />
          </div>
          <div class="col-md-4 mb-3 d-flex align-items-center">
            <div class="head-b">Pollution</div>
          </div>
          <div class="col-md-4 mb-3">
            <div class="dec">
              <mat-form-field>
                <mat-datepicker-toggle matSuffix [for]="picker4">
                </mat-datepicker-toggle>
                <mat-datepicker #picker4></mat-datepicker>
                <input matInput [matDatepicker]="picker4" placeholder="DD-MM-YYYY" [min]="minDate"
                  formControlName="pollution_expiry" (click)="picker4.open()" />
              </mat-form-field>
            </div>
          </div>
          <div class="col-md-4 d-flex align-items-center mb-3">
            <span (click)="uploadPollutionImage.click()" *ngIf="uploadPollution" class="image">Upload
            </span>
            <div *ngIf="updatePollution">
              <a target="_blank" href="{{ data.truck_documents_proofs.pollution }}">{{ pollutionImageName }}</a>
            </div>
            <div [class.spinner]="pollutionLoading"></div>
            <span *ngIf="!uploadPollution">{{ pollutionImageName }}</span>
            <img src="../../../assets/img/cross.svg" *ngIf="!uploadPollution" (click)="removeImg($event, 'pollution')"
              class="cross-btn" alt="" />
            <input #uploadPollutionImage type="file" (change)="onChange($event, 'Pollution')" hidden />
          </div>
          <div class="col-md-4 mb-3 d-flex align-items-center">
            <div class="head-b">Insurance</div>
          </div>
          <div class="col-md-4 mb-3">
            <div class="dec">
              <mat-form-field>
                <mat-datepicker-toggle matSuffix [for]="picker5">
                </mat-datepicker-toggle>
                <mat-datepicker #picker5></mat-datepicker>
                <input matInput [matDatepicker]="picker5" placeholder="DD-MM-YYYY" [min]="minDate"
                  formControlName="insurance_expiry" (click)="picker5.open()" />
              </mat-form-field>
            </div>
          </div>
          <div class="col-md-4 d-flex align-items-center mb-3">
            <span (click)="uploadInsuranceImage.click()" *ngIf="uploadInsurance" class="image">Upload
            </span>
            <div *ngIf="updateInsurance">
              <a target="_blank" href="{{ data.truck_documents_proofs.insurance }}">{{ insuranceImageName }}</a>
            </div>
            <div [class.spinner]="insuranceLoading"></div>
            <span *ngIf="!uploadInsurance">{{ insuranceImageName }}</span>
            <img src="../../../assets/img/cross.svg" *ngIf="!uploadInsurance" (click)="removeImg($event, 'insurance')"
              class="cross-btn" alt="" />
            <input #uploadInsuranceImage type="file" (change)="onChange($event, 'Insurance')" hidden />
          </div>
        </div>
      </div>
      <div class="fixed-btn">
        <button [class.spinner]="loading" [ngClass]="{ 'button-disabled': loading }" [disabled]="loading"
          (click)="UpdateTruck($event)">
          Save
        </button>
      </div>
    </form>
  </div>
</div>